import { render, staticRenderFns } from "./ccLive.vue?vue&type=template&id=165e325e&scoped=true"
import script from "./ccLive.vue?vue&type=script&lang=js"
export * from "./ccLive.vue?vue&type=script&lang=js"
import style0 from "./ccLive.vue?vue&type=style&index=0&id=165e325e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e325e",
  null
  
)

export default component.exports